<div class="modal-header">
  <h4 class="modal-title">Notes - {{ taskReference }} - {{ methodName}}</h4>
  <button type="button" class="close pull-right" (click)="close()">
    <i aria-hidden="true" class="fa fa-times"></i>
  </button>
</div>

<div class="modal-body" style="max-height: 500px; overflow-y: auto;">
  <!-- Loading indicator -->
  <div *ngIf="loading" class="text-center">
    <i class="fa fa-spinner fa-spin"></i> Loading...
  </div>

  <!-- Notes list -->
  <div *ngIf="!loading && !isEditMode && !showDeleteConfirmation">
    <div class="mb-3">
      <button type="button" class="btn btn-primary btn-sm" (click)="addNote()">
        <i class="fa fa-plus"></i> Add Note
      </button>
    </div>

    <div *ngIf="notes.length === 0" class="text-muted text-center p-4">
      No notes available. Click "Add Note" to create one.
    </div>

    <div *ngFor="let note of notes" class="card mb-3">
      <div class="card-header d-flex justify-content-between align-items-center">
        <strong>{{ note.createdByName || 'Unknown User' }}</strong>
        <div class="btn-group" *ngIf="canEditNote(note) || canDeleteNote(note)">
          <button 
            type="button" 
            class="btn btn-primary btn-sm" 
            (click)="editNote(note)"
            *ngIf="canEditNote(note)">
            <i class="fa fa-edit"></i>
          </button>
          <button 
            type="button" 
            class="btn btn-link delete-icon-btn" 
            (click)="deleteNote(note)"
            *ngIf="canDeleteNote(note)">
            <i class="fa action-icon fa-trash"></i>
          </button>
        </div>
      </div>
      <div class="card-body">
        <p class="card-text" style="white-space: pre-wrap;">{{ note.noteContent }}</p>
        <small class="text-muted">
          <ng-container *ngIf="note.modifiedDate && note.modifiedByName">
            Last modified by {{ note.modifiedByName }} on {{ formatDate(note.modifiedDate) }}<br>
          </ng-container>
          Created by {{ note.createdByName || 'Unknown User' }} on {{ formatDate(note.createdDate) }}
        </small>
      </div>
    </div>
  </div>

  <!-- Edit/Add note form -->
  <div *ngIf="!loading && isEditMode && !showDeleteConfirmation">
    <div class="mb-3">
      <h5>{{ editingNote ? 'Edit Note' : 'Add New Note' }}</h5>
    </div>

    <div class="mb-3">
      <label for="noteContent" class="form-label">Content <span class="text-danger">*</span></label>
      <textarea
        #noteContentInput
        id="noteContent"
        class="form-control"
        [(ngModel)]="newNoteContent"
        placeholder="Enter note content"
        rows="8"
        style="resize: vertical; min-height: 120px;">
      </textarea>
    </div>

    <div class="d-flex justify-content-end">
      <button type="button" class="btn btn-default cancel-btn" (click)="cancelEdit()">
        Cancel
      </button>
      <button 
        type="button" 
        class="btn btn-primary" 
        (click)="saveNote()"
        [disabled]="!newNoteContent.trim()">
        {{ editingNote ? 'Update' : 'Save' }}
      </button>
    </div>
  </div>

  <!-- Delete confirmation dialog -->
  <div *ngIf="!loading && showDeleteConfirmation">
    <div class="text-center">
      <h5 class="mb-4">Confirm Delete</h5>
      <div class="alert alert-warning mb-4">
        <i class="fa fa-exclamation-triangle"></i>
        Are you sure you want to delete this note? This action cannot be undone.
      </div>
      
      <div *ngIf="noteToDelete" class="card mb-4">
        <div class="card-header">
          <strong>{{ noteToDelete.createdByName || 'Unknown User' }}</strong>
        </div>
        <div class="card-body">
          <p class="card-text" style="white-space: pre-wrap;">{{ noteToDelete.noteContent }}</p>
          <small class="text-muted">
            Created on {{ formatDate(noteToDelete.createdDate) }}
          </small>
        </div>
      </div>

      <div class="d-flex justify-content-center">
        <button type="button" class="btn btn-default cancel-btn" (click)="cancelDelete()">
          <i class="fa fa-times"></i> Cancel
        </button>
  <button type="button" class="btn btn-primary" (click)="confirmDelete()">
          <i class="fa action-icon fa-trash"></i> Delete Note
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-default pull-right" (click)="close()">Close</button>
</div>
